import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { useAppSelector } from 'src/store/hooks';
import { isLmsWeb } from 'src/workspace/utils';
import { getKeyMetricsDetails } from '../selector';
import KeyMetricsHeader from './components/header';
import KeyMetricsOverview from './components/overview';
import TeamBreakdown from './components/teamBreakdown';
import styles from './index.module.scss';

function KeyMetricsDetails() {
  const details = useAppSelector(getKeyMetricsDetails);
  return (
    <div
      className={classnames(styles.details, {
        [styles.details__lmsWeb]: isLmsWeb() && !_.isEmpty(details),
      })}
    >
      <KeyMetricsHeader />
      <TeamBreakdown />
      <KeyMetricsOverview />
    </div>
  );
}

export default KeyMetricsDetails;
